import React from "react";

import { useSelector } from "react-redux";

import styles from "./XShareLink.module.css";

import mainIcon from './assets/twitter-x.svg'

const XShareLink = () => {

    const shareData = useSelector((state) => state.visualizer.shareData);

    const xUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareData.url)}&text=${shareData.message}`

    return (
        <a href={xUrl} target="_blank" rel="noopener noreferrer" aria-label="share to X link" className={styles.mainIcon}>
            <img src={mainIcon} alt="facebook icon"/>
        </a>
    );
};

export default XShareLink;